import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoggerService } from "./logger.service";
import { ConsoleLoggerService } from "./console-logger.service";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatToolbarModule } from "@angular/material/toolbar";

@NgModule({
  imports: [CommonModule, MatCardModule, MatToolbarModule],
  providers: [{ provide: LoggerService, useClass: ConsoleLoggerService }],
  declarations: [HeaderComponent, FooterComponent],
  exports: [HeaderComponent, FooterComponent]
})
export class CoreModule {}
